import React from 'react';

interface ProgressBarProps {
  current: number;
  total: number;
  percentage: number;
  currentStep: string;
  isVisible: boolean;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  current,
  total,
  percentage,
  currentStep,
  isVisible
}) => {
  if (!isVisible || total === 0) {
    return null;
  }

  return (
    <div className="bg-white border border-slate-200 rounded-lg p-4 shadow-sm">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium text-slate-700">
          {currentStep}
        </span>
        <span className="text-sm text-slate-500">
          {current}/{total} ({percentage}%)
        </span>
      </div>
      
      <div className="w-full bg-slate-200 rounded-full h-2.5">
        <div 
          className="bg-blue-600 h-2.5 rounded-full transition-all duration-300 ease-out"
          style={{ width: `${percentage}%` }}
        />
      </div>
      
      <div className="mt-2 text-xs text-slate-500">
        Sauvegarde en cours...
      </div>
    </div>
  );
};
